import PermissionsTemplatesMenu from "./PermissionsTemplatesMenu";

export default class PermissionsTemplatesMenuWithoutChoosing extends PermissionsTemplatesMenu {

    _appendInnerRowContent(rowInnerContent, templateData, isDefaultRow) {
        var context = this;
        var templateName = this._generateTemplateName(templateData, isDefaultRow);
        templateName.on('click',
            function() {
                if (context.isDisabledControls) {
                    return;
                }
                context.onEditTemplateCallback(templateData);
            }
        );
        rowInnerContent.append(templateName);
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/PermissionsTemplatesMenuWithoutChoosing.js